export default __webpack_public_path__ + "static/media/ru.1a25dd02.svg";